<template>
  <div class="no-tabs sent-geo-modal d-flex align-items-center justify-content-center custom-min-vh">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-3 col-md-5 col-sm-6 form-container">
          <div class="form-group">
            <label>Przedział tygodniowy</label>
            <Datepicker
              v-model="form.date_range"
              :locale="datePickerLocale"
              :now-button-label="$t('components.datepicker.nowText')"
              :partial-range="false"
              :placeholder="$t('components.datepicker.placeholder')"
              auto-apply
              format="dd/MM/yyyy"
              preview-format="dd/MM/yyyy"
              :required="true"
              :range="{ partialRange: false }"
            />
            <div
              v-for="error of v.form.date_range.$errors"
              :key="error.$uid"
              class="vuelidate-errors"
            >
              <p class="error-msg">
                {{ error.$message }}
              </p>
            </div>
          </div>

          <div class="form-group mt-3">
            <label>Pojazd</label>
            <vue-select
              class="vue-select"
              icon="bi bi-truck"
              label="label"
              :clearable="true"
              :options="vehicles"
              :value="vehicles.find(i => String(i.id) === String(form.vehicle_id))"
              @updateSelect="emitVehicle"
            />
            <div
              v-for="error of v.form.vehicle_id.$errors"
              :key="error.$uid"
              class="vuelidate-errors"
            >
              <p class="error-msg">
                {{ error.$message }}
              </p>
            </div>
          </div>

          <div class="text-center mt-3">
            <button
              class="btn btn-success btn-search"
              @click="generate"
            >
              {{ $t('modules.forms.report.btn_generate') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import {computed, defineComponent, watch} from 'vue';
import {useI18n} from "vue-i18n";
import { checkIfAdminOrBoss } from '@/utils/tools'
import VueSelect from "@/components/extras/VueSelect.vue";
import { VueDatePicker as Datepicker } from "@vuepic/vue-datepicker";
import { getMyVehicles } from '@/crud/getters'
import {required} from "@/vuelidate/i18n-validators";
import useVuelidate from "@vuelidate/core";
import {getWorkCard} from "@/components/content/_modules/forms/crud";
import { getDatePickerLocale } from '@/services/date-picker-locale';

export default defineComponent({
  name: 'ModulesFormsReport',
  components: {Datepicker, VueSelect},
  data() {
    return {
      moduleId: 1,
      pageTitle: this.$t('aside.menu.pages.modules.formsReport'),
      vehicles: [] as any,
      form: {
        vehicle_id: null as number | null,
        date_range: null as any,
      }
    }
  },
  setup() {
    const i18n = useI18n()
    const datePickerLocale = computed(() => getDatePickerLocale(i18n.locale.value))
    let reloaded = 0

    watch(() => i18n.locale.value, () => {
      reloaded++
    })
    return { datePickerLocale, reloaded, v: useVuelidate() }
  },
  validations: {
    form: {
      vehicle_id: { required },
      date_range: { required }
    }
  },
  methods: {
    emitVehicle(value): void {
        this.form.vehicle_id = value?.id ?? null
    },
    generate() {
      const self = this

      self.v.$touch()
      if (self.v.$invalid) {
        return false;
      }

      getWorkCard(self.form)
          .then((response) => {
            const now = new Date();
            const timestamp = now.toISOString().replace(/[:.]/g, '-').split('T').join('_').split('Z')[0];
            const filename = `vehicle_report_${timestamp}.pdf`;

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);

            self.form.vehicle_id = null
            self.form.date_range = null
            self.v.$reset();
          })
          .catch(() => {
            self.$toast.error(this.$t('modules.forms.data_get_error'));
          });
    }
  },
  mounted() {
    const self = this
    getMyVehicles()
        .then((response: any) => {
          while (this.vehicles.length > 0) {
            this.vehicles.pop()
          }
          response.data.forEach(function (obj) {
            obj.label = obj.registration + ' ('+ obj.device.imei +')'
            self.vehicles.push(obj)
          })
        })
  },
  beforeMount() {
    if (!checkIfAdminOrBoss()) {
      this.$router.push('/')
    }

    this.$emit('pageName', this.pageTitle)
    document.title = document.title + ' ' + this.$t('aside.menu.pages.modules.forms')
    this.$emit('emitGetComponentId', this.moduleId)
  }
})
</script>
<style scoped>
.custom-min-vh {
  min-height: calc(100vh - 68px);
}

.form-container {
  max-width: 500px;
  width: 100%;
}

.vue-select {
  width: 100%;
  min-width: 250px;
}

.form-group {
  width: 100%;
  text-align: left;
}
</style>
